module.exports = __webpack_public_path__ + "img/17.8425274a.png";